import { openFaceComparisonTab } from '@hakimo-ui/hakimo/util';
import { SquareArrowOutUpRight } from 'lucide-react';
import { useCallback, useState } from 'react';
import type { FaceProfileItemProps, FaceProfileOverlayProps } from '../types';

function FaceProfileItem({ face }: FaceProfileItemProps) {
  const [hasError, setHasError] = useState(false);

  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      openFaceComparisonTab({
        profileName: face.profile_name,
        employeeId: face.employee_id,
        badgeId: face.badge_id,
        profileType: face.profile_type,
        alarmType: face.alarmType,
        gender: face.gender,
        timestamp: face.timestamp,
        cameraName: face.cameraName,
        referencePrimaryUrl: face.image_path,
        referenceFullBodyUrl: face.full_body_image_path,
        frameUrl: face.frame_url,
        faceBox: face.face_box,
        personBox: face.person_box,
      });
    },
    [face]
  );

  return (
    <div className="h-20 flex-shrink-0 overflow-hidden">
      {hasError ? (
        <div className="flex h-full w-full items-center justify-center bg-gray-700 text-xs text-white">
          No Image
        </div>
      ) : (
        <button
          type="button"
          onClick={handleClick}
          className="group relative block h-full w-full cursor-pointer"
          title={face.profile_name}
        >
          <img
            src={face.image_path}
            alt={face.profile_name}
            className="h-full w-full object-cover"
            onError={() => setHasError(true)}
          />
          <span className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-0 transition-opacity group-hover:opacity-100">
            <span className="rounded p-1 text-white">
              <SquareArrowOutUpRight className="h-4 w-4" />
            </span>
          </span>
        </button>
      )}
    </div>
  );
}

export function FaceProfileOverlay({ matchedFaces }: FaceProfileOverlayProps) {
  if (!matchedFaces || matchedFaces.length === 0) {
    return null;
  }

  return (
    <div className="absolute left-0 top-0 z-10 flex gap-1">
      {matchedFaces.map((face) => (
        <FaceProfileItem key={face.profile_id} face={face} />
      ))}
    </div>
  );
}

export default FaceProfileOverlay;
